var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTracker48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7283 6.50293C26.7923 6.50293 24.2063 7.97962 22.6928 10.2206C21.6816 9.70928 20.535 9.42064 19.32 9.42064C15.2331 9.42064 11.92 12.6864 11.92 16.7149C11.92 16.7887 11.9211 16.8623 11.9233 16.9356C11.5717 16.8529 11.204 16.8101 10.8261 16.8101C8.16071 16.8101 6 18.9399 6 21.5672C6 24.1945 8.16071 26.3244 10.8261 26.3244C10.8422 26.3244 10.8584 26.3243 10.8745 26.3241L37.3696 26.3244L37.3694 26.3114C40.5137 26.1074 43 23.5289 43 20.3779C43 17.4997 40.9255 15.0991 38.17 14.5497C38.0212 10.0815 34.2987 6.50293 29.7283 6.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4205 37.0047C30.0556 37.0053 28.4024 37.0104 28.2075 37.0047C25.2831 36.9191 23.1787 33.5685 23.1787 29.5922C23.1787 23.5564 26.2833 18.518 29.2144 17.3363C29.607 17.1646 30.0125 17.0742 30.4214 17.0742L30.4466 17.0746L30.4717 17.0742C30.8806 17.0742 31.2862 17.1646 31.6788 17.3365C34.6098 18.518 37.7144 23.5564 37.7144 29.5922C37.7144 33.5685 35.61 36.9191 32.6856 37.0047C32.4908 37.0104 30.8375 37.0053 30.4726 37.0047H30.4205Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5811 28.0039V42.6215",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5811 34.6151L27.6201 31.4258",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTracker48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTracker48.c25fed74eea5c252525cc28c758c6648.svg";
export { ForwardRef as ReactComponent };